<template>
  <div :class="['informational-banner', pageClass]">
    <i
      class="hi hi-close hi-10"
      @click="dismiss"
    />

    <div class="wrapper">
      <div class="content">
        <h4 class="title">
          <i
            v-if="titleIcon"
            :class="`hi hi-${titleIcon} icon`"
          ></i>
          {{ title }}
        </h4>

        <span class="description">{{ message.text }}</span>

        <ul
          v-if="features"
          class="features"
        >
          <li
            v-for="(value, index) in features"
            :key="index"
          >
            {{ value }}
          </li>
        </ul>

        <div class="ctas">
          <slot
            v-if="primaryCta.text"
            name="primaryCta"
          >
            <a
              :href="primaryCta.url"
              :target="isExternal(primaryCta.url) ? '_blank' : '_self'"
              class="btn btn-sm primary-cta"
              @click="$emit('cta-clicked')"
            >
              {{ primaryCta.text }}
            </a>
          </slot>

          <a
            class="btn btn-sm secondary-cta"
            :href="secondaryCta.url || '#'"
            :target="isExternal(secondaryCta.url) ? '_blank' : '_self'"
            @click="handleSecondaryCta"
          >
            {{ secondaryCta.text }}
          </a>

          <div class="dismiss">
            <AppCheckbox v-model="dontShowAgain"> Don't show this again </AppCheckbox>
          </div>
        </div>
      </div>

      <div class="illustration-wrapper">
        <img
          class="illustration"
          :src="illustrationSrc"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { INFORMATIONAL_BANNER_ILLUSTRATIONS } from '~/app_constants';
export default {
  name: 'AppInfoBanner',
  props: {
    title: {
      type: String,
      required: true,
    },
    titleIcon: {
      type: String,
      required: false,
      default: null
    },
    page: {
      type: String,
      required: true,
    },
    illustration: {
      type: String,
      required: true,
    },
    features: {
      type: [Object, null],
      required: false,
      default: () => ({}),
    },
    message: {
      type: Object,
      required: true,
    },
    primaryCta: {
      type: Object,
      required: true,
    },
    secondaryCta: {
      type: Object,
      required: true,
    },
    analyticsInfo: {
      type: Object,
      required: true,
    },
    organizationId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    dontShowAgain: false,
  }),
  computed: {
    pageClass() {
      return this.page.replace(/_/g, '-');
    },
    illustrationSrc() {
      return INFORMATIONAL_BANNER_ILLUSTRATIONS[this.illustration];
    }
  },
  methods: {
    handleSecondaryCta(event) {
      if (this.secondaryCta.asDismiss) {
        event.preventDefault();
        this.dismiss();

        return;
      }

      if (this.secondaryCta.action) {
        event.preventDefault();
        this.executeAction(this.secondaryCta.action);
        
      }

      // If there's a URL, let the default behavior happen
    },
    executeAction(action) {
      // Parse action string: "action_name?param1=value1&param2=value2"
      const [actionName, paramsString] = action.split('?');
      
      switch (actionName) {
        case 'update_url_params':
          this.updateUrlParams(paramsString);
          break;
        default:
          console.warn(`Unknown action: ${action}`);
      }
    },
    updateUrlParams(paramsString) {
      const url = new URL(window.location);
      
      if (paramsString) {
        // Parse the params from the action string
        const params = new URLSearchParams(paramsString);

        params.forEach((value, key) => {
          url.searchParams.set(key, value);
        });
      }
      
      window.history.pushState({}, '', url);
    },
    dismiss() {
      if (this.dontShowAgain) {
        this.$emit('dismiss-promotion', 'info_banner', { dismissed_item: this.page });
      }
      this.$emit('close');
    },
    isExternal(url) {
      try {
        const parsedUrl = new URL(url, window.location.origin);

        return parsedUrl.origin !== window.location.origin;
      } catch {
        return false;
      }
    }
  },
};
</script>
